export const LOGIN_REQ="LOGIN_REQ";
export const LOGIN_SUCCESS_USER="LOGIN_SUCCESS_USER";
export const LOGIN_SUCCESS_ADMIN="LOGIN_SUCCESS_ADMIN";
export const LOGIN_FAILURE="LOGIN_FAILURE";
export const LOGIN_REGISTER_SUCCESS="LOGIN_REGISTER_SUCCESS";
export const LOG_OUT= "LOG_OUT";

// export const URL=`http://localhost:8080`
export const URL=`https://house-hunter-45uw.onrender.com`


